import React from 'react';
import NumberFormat from 'react-number-format';
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'

import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import './index.css'

function AllPlans({ plans }) {

  /**
     * Render month plan cards
     * @param {*} plan 
     */
  function makePlanCardsMonthly(plan) {
    return (
      <>
        {
          plan.cicle.map((cicle) => cicle.name === 'Mensal' ? (
            <Col md={4} key={cicle.id}>
              <Card className="text-center" style={{ width: '25rem' }} >
                <Card.Body>
                  <Card.Title>{plan.name}</Card.Title>
                  <h4>{cicle.name}</h4>

                  <div className="options">
                    {cicle.features.map((feature) => (
                      <p>{feature.name}</p>
                    ))}
                  </div>

                  <div className="container-value">
                    <span className="prefix-value">R$</span>
                    <span className="value"><NumberFormat value={cicle.value} displayType={'text'} decimalSeparator="," fixedDecimalScale={true} thousandSeparator="." decimalScale={2} prefix={''} /></span>
                    <span className="cicle">{cicle.name === 'Mensal' ? '/mês' : '/ano'}</span>
                  </div>

                  <Button variant="primary" onClick={(e) => 
                    // goToRegisterPage(plan, cicle)
                    console.log(plan)
                    } >Selecionar plano</Button>
                </Card.Body>
              </Card>
            </Col>
          ) : null)
        }
      </>
    )

  }


  /**
   * Render yearly plan cards
   * @param {*} plan 
   */
  function makePlanCardsYearly(plan) {
    return (
      <>
        {
          plan.cicle.map((cicle) => cicle.name !== 'Mensal' ? (
            <Col md={4} key={cicle.id}>
              <Card className="text-center" style={{ width: '25rem' }} >
                <Card.Body>
                  <Card.Title>{plan.name}</Card.Title>
                  <h4>{cicle.name}</h4>

                  <div className="options">
                    {cicle.features.map((feature) => (
                      <p>{feature.name}</p>
                    ))}
                  </div>

                  <div className="container-value">
                    <span className="prefix-value">R$</span>
                    <span className="value"><NumberFormat value={cicle.value} displayType={'text'} decimalSeparator="," fixedDecimalScale={true} thousandSeparator="." decimalScale={2} prefix={''} /></span>
                    <span className="cicle">{cicle.name === 'Mensal' ? '/mês' : '/ano'}</span>
                  </div>

                  <Button variant="primary" onClick={(e) => 
                    console.log(plan)
                    }>Selecionar plano</Button>
                </Card.Body>
              </Card>
            </Col>
          ) : null)
        }
      </>
    )

  }

  return (
    <section className="Plan">
      <Tabs defaultActiveKey="mensal" id="plans-tab">
        <Tab eventKey="mensal" title="Mensal">
          <Row>
            {plans.map((plan) => makePlanCardsMonthly(plan))}
          </Row>
        </Tab>
        <Tab eventKey="anual" title="Anual">
          <Row>
            {plans.map((plan) => makePlanCardsYearly(plan))}
          </Row>
        </Tab>
      </Tabs>
    </section>
  );
}

export default AllPlans;